var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bar-graph-widget" },
    [
      _vm._v(" Chart Data: " + _vm._s(_vm.chartData) + " "),
      _vm.statsData
        ? _c("BarGraph", {
            attrs: {
              "chart-data": _vm.chartData,
              options: _vm.options,
              responsive: ""
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }